(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diferencia-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvTsmdBound) return;
  window.__skinorvTsmdBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-tsmd-scroll-top]');
    if (!btn) return;
    e.preventDefault();
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientes-cards-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sliders = document.querySelectorAll('[data-slin-slider]');
  sliders.forEach(function (slider) {
    const track = slider.querySelector('[data-slin-track]');
    const btnPrev = slider.querySelector('[data-slin-prev]');
    const btnNext = slider.querySelector('[data-slin-next]');
    if (!track || !btnPrev || !btnNext) return;

    function getStep() {
      const card = track.querySelector('.slin__card');
      if (!card) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scroll(dir) {
      track.scrollBy({ left: getStep() * dir, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;
      const atStart = left <= 4;
      const atEnd = left >= max - 4 || max <= 0;
      btnPrev.classList.toggle('slin__flecha--disabled', atStart);
      btnNext.classList.toggle('slin__flecha--disabled', atEnd);
    }

    btnPrev.addEventListener('click', function () { scroll(-1); });
    btnNext.addEventListener('click', function () { scroll(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvFaqBound) return;
  window.__skinorvFaqBound = true;

  document.addEventListener('toggle', function (e) {
    const item = e.target;
    if (!item || typeof item.hasAttribute !== 'function') return;
    if (!item.hasAttribute('data-faq-item')) return;
    if (!item.open) return;

    const grid = item.closest('[data-faq-grid]');
    if (!grid) return;

    const others = grid.querySelectorAll('[data-faq-item]');
    others.forEach(function (other) {
      if (other !== item && other.hasAttribute('open')) {
        other.removeAttribute('open');
      }
    });
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-result-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sliders = document.querySelectorAll('[data-rres-slider]');
  sliders.forEach(function (slider) {
    const track = slider.querySelector('[data-rres-track]');
    const btnPrev = slider.querySelector('[data-rres-prev]');
    const btnNext = slider.querySelector('[data-rres-next]');
    if (!track || !btnPrev || !btnNext) return;

    function getStep() {
      const card = track.querySelector('.rres__card');
      if (!card) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scroll(dir) {
      track.scrollBy({ left: getStep() * dir, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;
      const atStart = left <= 4;
      const atEnd = left >= max - 4 || max <= 0;
      btnPrev.classList.toggle('rres__flecha--disabled', atStart);
      btnNext.classList.toggle('rres__flecha--disabled', atEnd);
    }

    btnPrev.addEventListener('click', function () { scroll(-1); });
    btnNext.addEventListener('click', function () { scroll(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvLovdBound) return;
  window.__skinorvLovdBound = true;

  function lovdRestore(media) {
    if (!media) return;
    media.querySelectorAll('.lovd__video, .lovd__iframe').forEach(function (el) {
      if (el.tagName === 'VIDEO') { try { el.pause(); } catch (err) {} }
      el.parentNode.removeChild(el);
    });
    media.setAttribute('data-lovd-playing', 'false');
  }

  function lovdForce(el) {
    var s = el.style;
    s.setProperty('position', 'absolute', 'important');
    s.setProperty('top', '0', 'important');
    s.setProperty('left', '0', 'important');
    s.setProperty('width', '100%', 'important');
    s.setProperty('height', '100%', 'important');
    s.setProperty('max-width', 'none', 'important');
    s.setProperty('max-height', 'none', 'important');
    s.setProperty('display', 'block', 'important');
    s.setProperty('object-fit', 'cover', 'important');
    s.setProperty('z-index', '3', 'important');
    s.setProperty('background', '#000', 'important');
    s.setProperty('border', '0', 'important');
    s.setProperty('margin', '0', 'important');
    s.setProperty('padding', '0', 'important');
  }

  function lovdPlay(media) {
    if (!media || media.getAttribute('data-lovd-playing') === 'true') return;
    var type = media.getAttribute('data-video-type');
    var source = media.getAttribute('data-video-source');
    if (!type || !source) return;
    var section = media.closest('.lovd');
    if (section) {
      section.querySelectorAll('[data-lovd-video][data-lovd-playing="true"]').forEach(function (m) {
        if (m !== media) lovdRestore(m);
      });
    }
    if (type === 'mp4') {
      var video = document.createElement('video');
      video.className = 'lovd__video';
      video.src = source;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.setAttribute('disablepictureinpicture', '');
      video.preload = 'metadata';
      lovdForce(video);
      media.appendChild(video);
      try { video.play(); } catch (err) {}
    } else {
      var iframe = document.createElement('iframe');
      iframe.className = 'lovd__iframe';
      iframe.src = source;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      lovdForce(iframe);
      media.appendChild(iframe);
    }
    media.setAttribute('data-lovd-playing', 'true');
  }

  function lovdPosterFallback() {
    document.querySelectorAll('[data-lovd-video]').forEach(function (media) {
      if (media.getAttribute('data-lovd-fb') === '1') return;
      media.setAttribute('data-lovd-fb', '1');
      var type = media.getAttribute('data-video-type');
      var src = media.getAttribute('data-video-source');
      function addFrame() {
        if (type !== 'mp4' || !src || media.querySelector('.lovd__video-poster--frame')) return;
        var v = document.createElement('video');
        v.className = 'lovd__video-poster lovd__video-poster--frame';
        v.src = src + '#t=0.1';
        v.muted = true;
        v.preload = 'metadata';
        v.setAttribute('playsinline', '');
        v.setAttribute('muted', '');
        v.setAttribute('aria-hidden', 'true');
        v.tabIndex = -1;
        media.insertBefore(v, media.firstChild);
        var ph = media.querySelector('.lovd__placeholder');
        if (ph) ph.style.display = 'none';
      }
      var img = media.querySelector('[data-lovd-poster-img]');
      if (img) {
        img.addEventListener('error', function () { img.parentNode && img.parentNode.removeChild(img); addFrame(); });
        if (img.complete && img.naturalWidth === 0) { img.parentNode.removeChild(img); addFrame(); }
      } else if (media.querySelector('.lovd__placeholder')) {
        addFrame();
      }
    });
  }
  lovdPosterFallback();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lovdPosterFallback);
  document.addEventListener('shopify:section:load', function () { setTimeout(lovdPosterFallback, 50); });

  function lovdScale() {
    document.querySelectorAll('.lovd').forEach(function (sec) {
      var cfg = sec.querySelector('[data-lovd-cfg]');
      var mobile = window.innerWidth < 990;
      if (!cfg || !mobile) {
        sec.removeAttribute('data-lovd-scaled');
        return;
      }
      var ref = parseFloat(cfg.getAttribute('data-ref')) || 300;
      sec.setAttribute('data-lovd-scaled', 'true');
      sec.querySelectorAll('.lovd__card').forEach(function (card) {
        var w = card.getBoundingClientRect().width;
        var z = Math.min(1, Math.max(0.2, w / ref));
        card.style.setProperty('--lovd-z', z.toFixed(3));
      });
    });
  }
  lovdScale();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lovdScale);
  window.addEventListener('load', lovdScale);
  window.addEventListener('resize', function () { clearTimeout(window.__lovdScaleT); window.__lovdScaleT = setTimeout(lovdScale, 100); });
  document.addEventListener('shopify:section:load', function () { setTimeout(lovdScale, 50); });

  document.addEventListener('click', function (e) {
    const media = e.target.closest('[data-lovd-video]');
    if (media) {
      if (media.getAttribute('data-lovd-playing') === 'true') return;
      e.preventDefault();
      lovdPlay(media);
      return;
    }

    const btn = e.target.closest('[data-lovd-read-more]');
    if (btn) {
      e.preventDefault();
      const wrap = btn.closest('[data-lovd-review]');
      if (!wrap) return;
      const expanded = wrap.getAttribute('data-expanded') === 'true';
      wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
      const textMore = btn.getAttribute('data-text-more') || 'Read More';
      const textLess = btn.getAttribute('data-text-less') || 'Read Less';
      btn.textContent = expanded ? textMore : textLess;
      return;
    }

    const prev = e.target.closest('[data-lovd-prev]');
    const next = e.target.closest('[data-lovd-next]');
    if (prev || next) {
      const slider = (prev || next).closest('[data-lovd-slider]');
      if (!slider) return;
      const track = slider.querySelector('[data-lovd-track]');
      if (!track) return;
      const card = track.querySelector('.lovd__card');
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: step * (prev ? -1 : 1), behavior: 'smooth' });
    }
  });

  function updateArrows(slider) {
    const track = slider.querySelector('[data-lovd-track]');
    const prev = slider.querySelector('[data-lovd-prev]');
    const next = slider.querySelector('[data-lovd-next]');
    if (!track || !prev || !next) return;
    const max = track.scrollWidth - track.clientWidth;
    const left = track.scrollLeft;
    prev.classList.toggle('lovd__flecha--disabled', left <= 4);
    next.classList.toggle('lovd__flecha--disabled', left >= max - 4 || max <= 0);
  }

  document.querySelectorAll('[data-lovd-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-lovd-track]');
    if (!track) return;
    track.addEventListener('scroll', function () { updateArrows(slider); }, { passive: true });
    setTimeout(function () { updateArrows(slider); }, 50);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-lovd-slider]').forEach(updateArrows);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
